<template lang="pug">
	.chart
		DxChart(
			:id="id",
			:data-source="dataSource",
			:size="size",
			:palette="palette",
		)
			DxCommonSeriesSettings(
				:type="type"
				:bar-padding="barPadding"
				:argument-field="argumentField"
			)
			DxSeries(
				v-for="item in series",
				:key="item.value",
				:value-field="item.value",
				:name="item.name",
				:axis="item.axis"
			)
			slot(name="tooltip")
				DxTooltip(
					:enabled="true"
				)
			DxLegend(
				:vertical-alignment="legend.vertical"
				:horizontal-alignment="legend.horizontal"
			)
			slot(name="axis")
</template>

<script>
	import {
		DxChart,
		DxSeries,
		DxCommonSeriesSettings,
		DxLegend,
		DxExport,
		DxTitle,
		DxTooltip,
		DxValueAxis,
		DxArgumentAxis,
		DxLabel,
	} from 'devextreme-vue/chart';
	import VueTypes from "vue-types";

	export default {
		translationCategory: 'logs.components.Chart',
		name: "LogsChart",
		props: {
			id: VueTypes.string.def(`chart-id-${(+new Date).toString(16)}`),
			dataSource: VueTypes.array.def([]),
			type: VueTypes.string.def('bar'),
			series: VueTypes.array.def([]),
			isLabel: VueTypes.bool.def(true),
			size: VueTypes.object.def({ height: 300 }),
			legend: VueTypes.object.def({ vertical: 'top', horizontal: 'center' }),
			barPadding: VueTypes.number.def(0.75),
			argumentField: VueTypes.string.def(null),
			palette: VueTypes.any.def('Soft Pastel'),
			maxValue: VueTypes.any.def(null),
		},
		components: {
			DxChart,
			DxSeries,
			DxCommonSeriesSettings,
			DxLegend,
			DxExport,
			DxTitle,
			DxTooltip,
			DxValueAxis,
			DxArgumentAxis,
			DxLabel,
		},
	}
</script>

<style scoped>
	.chart {
		width: 100%;
	}
</style>
